// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicWebV1ReviewReplyRequest,
  TPublicWebV1ReviewReplyModel,
  IMappers,
  TPublicWebV1ReviewReplyResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicWebV1ReviewReplyResponseSchema } from '../../../../entities/response/PublicWebV1ReviewReplyResponseSchema';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createPublicWebV1ReviewReplyModel(
  parameters: TPublicWebV1ReviewReplyRequest,
): TPublicWebV1ReviewReplyModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/web/v1/review/reply/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicWebV1ReviewReplyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicWebV1ReviewReplyRequest;
}

export async function fetchPublicWebV1ReviewReply<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicWebV1ReviewReplyOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicWebV1ReviewReplyResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicWebV1ReviewReplyModel(parameters),
    config,
  )) as FetchResponse<TPublicWebV1ReviewReplyResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicWebV1ReviewReplyResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicWebV1ReviewReplyResponse>;
}
